<template>
    <div>
        <div>
            <img class="sbjj" src="~@public/img/hotApply/icon_sbjj.jpg">
        </div>
        <p class="title">长按图片，识别身边警局小程序</p>
    </div>
</template>

<script>
    export default {
        name: "PoliceMap"
    }
</script>

<style scoped>
    .sbjj {
        width: 75%;
        margin: 4.0rem 1.0rem 1.0rem 1.2rem
    }
    .title{
        font-size: 0.5rem;
        text-align: center;
        color:black;
    }
</style>